import { createContext, useContext, ReactNode } from "react";
import { useAuth } from "../hooks/useAuth";

// Define the shape of the auth context
interface AuthContextType {
    currentUser: any;
    setCurrentUser: (user: any) => void;
    signingIn: boolean;
    setSigningIn: (signingIn: boolean) => void;
    signInWithGoogle: () => void;
    signInWithEmailAndPassword: (email: string, password: string) => void;
    signOut: () => void;
    logoutInProgress: boolean;
    checkTokenAndProceed: () => Promise<any>;
}

// Create context with default values
const AuthContext = createContext<AuthContextType>({
    currentUser: null,
    setCurrentUser: () => {},
    signingIn: false,
    setSigningIn: () => {},
    signInWithGoogle: () => {},
    signInWithEmailAndPassword: () => {},
    signOut: () => {},
    logoutInProgress: false,
    checkTokenAndProceed: async () => {},
});

export const useAuthContext = () => useContext(AuthContext);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
    const auth = useAuth();

    return (
        <AuthContext.Provider value={auth}>
            {children}
        </AuthContext.Provider>
    );
};
